import { useEffect, useRef, useState } from "react";
import { useReducedMotion } from "framer-motion";

// Counts up to `end` once, when triggered. Respects reduced motion.
export function useCountUp(end, { duration = 2000, start = false } = {}) {
  const [value, setValue] = useState(0);
  const reduce = useReducedMotion();
  const raf = useRef();
  const done = useRef(false);

  useEffect(() => {
    if (!start || done.current) return;
    done.current = true;

    if (reduce) {
      setValue(end);
      return;
    }

    const t0 = performance.now();
    const tick = (now) => {
      const p = Math.min((now - t0) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setValue(Math.round(end * eased));
      if (p < 1) raf.current = requestAnimationFrame(tick);
    };
    raf.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf.current);
  }, [start, end, duration, reduce]);

  return value;
}
